/* export var estilos_informes = `
p,div,h1{
    font-family: Arial !important';
} 
.hoz table,.hoz td{
    border:1px solid black;
} 
table,tr,td{
    margin:0;
    padding:0;
} 
.hoz thead td{
    background: black;color: white; 
    font-weight: bold;
    border:1px solid black; 
} 
.hoz td{
    text-align:center;
} 
img{
    width:100px;
} 
table,tr,td{
    margin:0;
    padding:0;
} 
table.cabecera{ 
    border-collapse: collapse;
} 
.cabecera tr,.cabecera td {
    border: 1px solid black;
}
p,td,th {
    font-size: 14px;
} 
.cabecera { 
    width: 100%
}`; */
export var estilo_informe_conformidad=`.background-grey{
    background-color: #6C757D;
    color: aliceblue;
}
.background-dark{
    background-color: #343A40;
    color: aliceblue;

}`
export var estilos_informes =`
*{
    font-family: Arial;
    font-size: 12px;
}

.cabecera-section{
    width: 100%;
}

.cabecera-section td{
    text-align: center;
    border: 1px solid black;
}

.cabecera-section td p, .firmas tbody p{
    text-align: center;
    color: black;
}

.title-cabecera{
    text-align: center; 
    min-width: 100%;
    font-weight: bold;
    color: black;
}

.information{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
}

.information-row{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: start;
}

.information div{
    width: 100%;
    margin-bottom: 0.5rem;
}

.information div p, .information-row div p{
    color: black;
}

.information div p b, .information-row div p b{
    font-weight: bold;
}

.information h5, .table-informe h5{
    width: 100%;
    text-align: start;
    text-decoration: underline;
}

.information-max-container{
    max-height: 15rem;
    overflow-y: auto;
}

.firmas th{
    padding-right: 15px;
}

.firmas{
    font-size: 12px;
    font-family: Arial;
}

.limpieza-informe td{
    text-align: center;
}

.firmas thead tr th{
    text-align: left;
}

.firmas thead th, .limpieza-informe td{
    font-size: 12px;
    font-family: Arial;
}

.table-informe td, .limpieza-informe td{
    border: 1px solid black;
}

.limpieza-informe-title td, .limpieza-informe-title-lateral{
    text-align: center; 
    background: black;
    color: white;
    font-weight: bold;
}

.hiddenButtons {
    display: none;
}
`;

